import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/** React & Redux imports */ import React from 'react';
import { useDispatch } from 'react-redux';
import './dictionary-history-cols.scss';
import { showFeedback } from '../../../actions/ui';
/** Enums Imports */ import { RequestTypeEnum, RequestStatus } from './dictionary-history-enum';
/** Tools imports */ import ClipboardJS from 'clipboard';
/** declaration and events for clipboard js tool */ const clipboard = new ClipboardJS('.link_uri');
/**
 * Function React component for URI S3 with copy clipboard feature
 * @param param0
 * @returns
 */ const URIS3Link = ({ dictionaryCsvS3Uri })=>{
    const dispatch = useDispatch();
    // events for clipboard control
    clipboard.on('success', function(e) {
        dispatch(showFeedback({
            id: Date.now(),
            message: `S3 URI copied.`,
            dismissable: true,
            className: 'feedback-working'
        }));
    });
    clipboard.on('error', function(e) {
        dispatch(showFeedback({
            id: Date.now(),
            message: `S3 URI can not be copied.`,
            dismissable: true,
            className: 'feedback-error'
        }));
    });
    return /*#__PURE__*/ _jsx("a", {
        href: "/#",
        title: dictionaryCsvS3Uri,
        className: "link_uri",
        "data-clipboard-text": dictionaryCsvS3Uri,
        children: "copy"
    });
};
/**
 * Export definition of colums for dictionary history
 */ export default [
    {
        key: 'id',
        displayName: 'Index'
    },
    {
        key: 'requestType',
        displayName: 'Type',
        transform: (rowValue)=>{
            const { requestType } = rowValue;
            const requestTypeValue = RequestTypeEnum[requestType];
            return requestTypeValue;
        }
    },
    {
        key: 'requestStatus',
        displayName: 'Status',
        transform: (rowValue)=>{
            const { requestStatus } = rowValue;
            const requestStatusValue = RequestStatus[requestStatus];
            return requestStatusValue;
        }
    },
    {
        key: 'dictionaryCsvS3Uri',
        displayName: 'S3 URI',
        transform: (rowValue)=>{
            const { dictionaryCsvS3Uri } = rowValue;
            if (dictionaryCsvS3Uri && dictionaryCsvS3Uri.length > 0) {
                return /*#__PURE__*/ _jsxs("div", {
                    className: "section_uri",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "text_uri",
                            children: dictionaryCsvS3Uri
                        }),
                        /*#__PURE__*/ _jsx(URIS3Link, {
                            dictionaryCsvS3Uri: dictionaryCsvS3Uri
                        })
                    ]
                });
            }
            return;
        }
    },
    {
        key: 'updatedByFullName',
        displayName: 'Updated By'
    },
    {
        key: 'updatedDate',
        displayName: 'Date Updated'
    }
];
export const dictionaryListcolDefs = [
    {
        headerName: 'Index',
        field: 'id'
    },
    {
        field: 'requestType',
        headerName: 'Type',
        sortable: false
    },
    {
        field: 'requestStatus',
        headerName: 'Status',
        sortable: false
    },
    {
        field: 'dictionaryCsvS3Uri',
        headerName: 'S3 URI',
        sortable: false
    },
    {
        headerName: 'Download',
        field: 'dictionaryCsvS3Uri',
        sortable: false
    },
    {
        headerName: 'Updated By',
        field: 'updatedByFullName',
        sortable: false
    },
    {
        headerName: 'Date Updated',
        field: 'updatedDate',
        sortable: false
    }
];
